import { createSlice } from "@reduxjs/toolkit";
import { DataState } from "./types";

export const initialState: DataState = {
  newsData: {
    response: "",
    loading: false,
    error: false,
    initialLoad: false,
  },
  audioData: {
    audio: [{}],
    loading: false,
    error: false,
    audioData: null,
    isModalOpen: false,
    generatedAudios: [],
    notifications: [],
    notificationCount: 0,
    generatedTime: "",
  },
  videoData: {
    video: [{}],
    loading: false,
    error: false,
    videoData: null,
    isModalOpen: false,
    VidNotifications: [],
    generatedVideos: [],
    generatedTime: "",
  },
  analyzeData: {
    analyzedArticles: [],
    loading: false,
    error: false,
    success: false,
    currentArticle: "",
  },
  generatedArticle: {
    response: "",
    loading: false,
    error: false,
    initialArticleLoad: false,
  },
  generatedAnnouncement: {
    response: "",
    loading: false,
    error: false,
    initialAnnouncementLoad: false,
    language: "english",
  },
  heygenData: {
    loading: false,
    error: false,
    isModalOpen: false,
    generatedTime: "",
  },
  captionedNewsReelData: {
    loading: false,
    error: false,
    isModalOpen: false,
    generatedTime: "",
  },
};

export const dataSlice: any = createSlice({
  name: "dataApi",
  initialState,
  reducers: {
    getNewsData: (state) => {
      state.newsData.loading = true;
      state.newsData.initialLoad = true;
    },

    getNewsDataSuccess: (state, action) => {
      state.newsData.response += action.payload;
      state.newsData.initialLoad = false;
    },

    getNewsDataFailed: (state) => {
      state.newsData.loading = false;
      state.newsData.error = false;
    },
    resetNews: (state) => {
      state.newsData.response = "";
    },
    newsLoadComplete: (state) => {
      state.newsData.loading = false;
    },
    getAudioData: (state) => {
      state.audioData.loading = true;
    },

    getAudioSuccess: (state, action) => {
      state.audioData.generatedAudios.push(action.payload.audio);
      state.audioData.notifications.push({
        audio: action.payload.audio,
        generatedTime: action.payload.generatedTime,
      });
      state.audioData.loading = false;
    },

    openAudioModal(state, action) {
      state.audioData.isModalOpen = true;
      state.audioData.audio = action.payload;
    },

    openVideoModal(state, action) {
      state.videoData.isModalOpen = true;
      state.videoData.video = action.payload;
    },
    closeAudioModal(state) {
      state.audioData.isModalOpen = false;
    },
    clearNotifications(state) {
      state.audioData.notificationCount = 0;
    },
    getAudioFailed: (state) => {
      state.audioData.loading = false;
      state.audioData.error = true;
    },

    // getDataNull: (state) => {
    //   state.videoData.videoPath = "";
    // },
    getVideoData: (state) => {
      state.videoData.loading = true;
    },

    getVideoSuccess: (state, action) => {
      state.videoData.generatedVideos.push(action.payload.audio);
      state.audioData.notifications.push({
        audio: action.payload.audio,
        generatedTime: action.payload.generatedTime,
      });
      state.audioData.loading = false;
      state.videoData.loading = false;
    },

    getVideoFailed: (state) => {
      state.videoData.loading = false;
      state.videoData.error = true;
    },

    getHeygenData: (state) => {
      state.heygenData.loading = true;
    },

    getHeygenDataSuccess: (state, action) => {
      state.videoData.generatedVideos.push(action.payload.audio);
      state.audioData.notifications.push({
        audio: action.payload.audio,
        generatedTime: action.payload.generatedTime,
      });
      state.audioData.loading = false;
      state.videoData.loading = false;
      state.heygenData.loading = false;
    },

    getHeygenDataFailed: (state) => {
      state.heygenData.loading = false;
      state.heygenData.error = true;
    },
    getCaptionedNewsReelData: (state) => {
      state.captionedNewsReelData.loading = true;
    },
    getCaptionedNewsReelDataSuccess: (state, action) => {
      state.videoData.generatedVideos.push(action.payload.audio);
      state.audioData.notifications.push({
        audio: action.payload.audio,
        generatedTime: action.payload.generatedTime,
      });
      state.audioData.loading = false;
      state.videoData.loading = false;
      state.captionedNewsReelData.loading = false;
    },
    getCaptionedNewsReelDataFailed: (state) => {
      state.captionedNewsReelData.loading = false;
      state.captionedNewsReelData.error = true;
    },
    getAnalyzeArticle: (state) => {
      state.analyzeData.loading = true;
      state.analyzeData.success = false;
    },

    getAnalyzeArticleSuccess: (state, action) => {
      state.analyzeData.analyzedArticles = [
        ...state.analyzeData.analyzedArticles,
        action.payload,
      ];
      state.analyzeData.loading = false;
      state.analyzeData.success = true;
    },

    getAnalyzeArticleFailed: (state) => {
      state.analyzeData.loading = false;
      state.analyzeData.error = false;
    },
    currentAnalyzedArticle: (state, action) => {
      state.analyzeData.currentArticle = action.payload;
    },

    getGenerateArticle: (state) => {
      state.generatedArticle.loading = true;
      state.generatedArticle.initialArticleLoad = true;
    },

    getGenerateArticleSuccess: (state, action) => {
      state.generatedArticle.response += action.payload;
      state.generatedArticle.initialArticleLoad = false;
    },

    getGenerateArticleFailed: (state) => {
      state.generatedArticle.loading = false;
      state.generatedArticle.error = false;
    },
    resetArticle: (state) => {
      state.generatedArticle.response = "";
    },
    articleLoadComplete: (state) => {
      state.generatedArticle.loading = false;
    },

    getReGenerateArticle: (state) => {
      state.generatedArticle.loading = true;
      state.generatedArticle.initialArticleLoad = true;
    },

    getReGenerateArticleSuccess: (state, action) => {
      state.generatedArticle.response += action.payload;
      state.generatedArticle.initialArticleLoad = false;
    },

    getReGenerateArticleFailed: (state) => {
      state.generatedArticle.loading = false;
      state.generatedArticle.error = false;
    },
    reResetArticle: (state) => {
      state.generatedArticle.response = "";
    },
    reArticleLoadComplete: (state) => {
      state.generatedArticle.loading = false;
    },
    getGenerateAnnouncement: (state) => {
      state.generatedAnnouncement.loading = true;
      state.generatedAnnouncement.initialAnnouncementLoad = true;
    },
    getGenerateAnnouncementSuccess: (state, action) => {
      state.generatedAnnouncement.response += action.payload;
      state.generatedAnnouncement.initialAnnouncementLoad = false;
    },
    getGenerateAnnouncementFailed: (state) => {
      state.generatedAnnouncement.loading = false;
      state.generatedAnnouncement.error = true;
    },
    resetAnnouncement: (state) => {
      state.generatedAnnouncement.response = "";
    },
    announcementLoadComplete: (state) => {
      state.generatedAnnouncement.loading = false;
    },
    setAnnouncementLanguage: (state, action) => {
      state.generatedAnnouncement.language = action.payload;
    },
    markNotificationAsRead: (state, action) => {
      const $oid = action.payload;
      const notification = state.audioData.notifications.find(
        (n) => n.audio?.doc_id?.$oid === $oid
      );

      // Check if notification and notification.audio exist before accessing 'read'
      if (notification && notification.audio) {
        notification.audio.read = true;
      }
    },
  },
});

export const {
  getNewsData,
  stopNewsData,
  getNewsDataSuccess,
  resetNews,
  newsLoadComplete,
  getNewsDataFailed,
  getAudioData,
  getAudioSuccess,
  openAudioModal,
  closeAudioModal,
  clearNotifications,
  // getDataNull,
  getAudioFailed,
  getVideoData,
  getVideoSuccess,
  getVideoFailed,
  getHeygenData,
  getHeygenDataSuccess,
  getHeygenDataFailed,
  getCaptionedNewsReelData,
  getCaptionedNewsReelDataSuccess,
  getCaptionedNewsReelDataFailed,
  getAnalyzeArticle,
  getAnalyzeArticleSuccess,
  getAnalyzeArticleFailed,
  currentAnalyzedArticle,
  getGenerateArticle,
  getGenerateArticleSuccess,
  getGenerateArticleFailed,
  resetArticle,
  articleLoadComplete,
  getReGenerateArticle,
  getReGenerateArticleSuccess,
  getReGenerateArticleFailed,
  reResetArticle,
  ReArticleLoadComplete,
  getGenerateAnnouncement,
  getGenerateAnnouncementSuccess,
  getGenerateAnnouncementFailed,
  resetAnnouncement,
  announcementLoadComplete,
  setAnnouncementLanguage,
  openVideoModal,
  markNotificationAsRead,
} = dataSlice.actions;

export default dataSlice.reducer;
